import { TextField } from "@mui/material";
import { useState, useEffect } from "react";

import Svg from "../../../../ui library/components/svgs/standard/svg";
import HNSColors from "../../../../ui library/HNSColors";
import { useContactStore } from "../../hooks/useContactStore";

export default function SearchBar() {
  const { search, setSearchInput } = useContactStore();
  const [localSearch, setLocalSearch] = useState(search);

  useEffect(() => {
    const handler = setTimeout(() => {
      setSearchInput(localSearch);
    }, 700);

    return () => {
      clearTimeout(handler);
    };
  }, [localSearch, setSearchInput]);

  return (
    <div
      className="inline-flex content-center items-center rounded-[500px] border-[1px]"
      style={{ borderColor: HNSColors.secondary[800] }}
    >
      <div className="my-1 px-4">
        <Svg name="his-magnifying-glass" color={HNSColors.neutrals[600]} />
      </div>
      <div>
        <TextField
          id="search-bar"
          label="Search"
          className="w-96"
          variant="outlined"
          value={localSearch}
          onChange={(e) => setLocalSearch(e.target.value)}
          slotProps={{ inputLabel: { shrink: false } }}
          sx={{
            "& .MuiOutlinedInput-root": {
              "& fieldset": { border: "none" },
              "&:hover fieldset": { border: "none" },
              "&.Mui-focused fieldset": { border: "none" },
            },
            "& .MuiInputLabel-shrink": { display: "none" },
          }}
        />
      </div>
    </div>
  );
}
